import { TuiTabs } from '@taiga-ui/kit';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IsLoadingService } from '@core/services/is-loading.service';
import {
  RequestFormFilesRoutePaths,
  RequestFormFilesTabTitlesTranslateKeys,
} from './types/request-form-files-route-paths';
import { AsyncPipe } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { DeviceDetectorService } from '@core/services';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'x-request-form-files',
  imports: [
    TuiTabs,
    AsyncPipe,
    RouterLinkActive,
    RouterLink,
    RouterOutlet,
    TranslatePipe,
  ],
  templateUrl: './request-form-files.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestFormFilesComponent {
  readonly isLoading$ = inject(IsLoadingService);
  readonly RequestFormFilesTabTitlesTranslateKeys: any =
    RequestFormFilesTabTitlesTranslateKeys;
  readonly tabs = Object.values(RequestFormFilesRoutePaths);
  public tabIndex = 0;
  readonly deviceService = inject(DeviceDetectorService);
}
